import { CapoPlugin } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];